import React from 'react';
import './ShimmerLoader.css';

const ShimmerLoader = ({ width, height, borderRadius, style, className }) => {
  const styles = {
    width: width || '100%',
    height: height || '16px',
    borderRadius: borderRadius || '4px',
    ...style,
  };

  return (
    <div
      className={`shimmer-loader ${className || ''}`}
      style={styles}
    />
  );
};

export default ShimmerLoader;
